import React from 'react'
import { StyledIcon } from '../StyledIcon'
import { StyledIconPropsType } from './types'

const AddIconWMO = ({ 
  icon = "addImage",
  color= "dark-2",
  viewBox = "0 0 40 40",
  width = "40px",
  height = "40px",
  customProps = {}
 }: StyledIconPropsType) => {
  return (
    <StyledIcon
      width={width}
      height={height}
      viewBox={viewBox}
      a11yTitle={icon}
      color={color}
      {...customProps}
    >
      <g clipPath="url(#clip0_1_9701)">
        <path d="M31.6663 21.6667H21.6663V31.6667H18.333V21.6667H8.33301V18.3334H18.333V8.33337H21.6663V18.3334H31.6663V21.6667Z" fill="#282832"/>
      </g>
      <defs>
        <clipPath id="clip0_1_9701">
          <rect width="40" height="40" fill="white"/>
        </clipPath>
      </defs>
    </StyledIcon>
  )
}

export default AddIconWMO
